<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>Strategic Plan Summary</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-card>
            <v-row>
              <v-col cols="8" class="flex-items mt-2">
                <div class="text-body-1 pa-2">Goals</div>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="2" class="d-flex justify-end mt-2 mr-2">
                <!-- <v-btn
                  @click="AddFunction()"
                  class="white--text rounded-lg"
                  color="#519043"
                >
                  Add
                </v-btn> -->
              </v-col>
              <v-col cols="12" class=" pt-2 px-4">
                <v-data-table
                  :expanded1.sync="expanded1"
                  :headers="headers"
                  show-expand
                  single-expand
                  :items="dataItem"
                  :items-per-page="10"
                  @item-expanded="loadStrategicOutcomes"
                >
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-4">
                      <div class="text-subtitle-1 py-1">Strategic Outcomes</div>
                      <div>
                        <v-data-table
                          :expanded2.sync="expanded2"
                          :headers="strategy_outcome_headers"
                          :items="item.strategy_outcome_data"
                          show-expand
                          single-expand
                          hide-default-footer
                          @item-expanded="loadSOStategies"
                        >
                          <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="pa-4">
                              <div class="text-subtitle-1 py-1">
                                Strategy
                              </div>
                              <div>
                                <v-data-table
                                  :expanded3.sync="expanded3"
                                  :headers="strategy_headers"
                                  :items="item.strategy_data"
                                  single-expand
                                  show-expand
                                  hide-default-footer
                                  @item-expanded="loadPAP"
                                >
                                  <template
                                    v-slot:[`item.description`]="{ item }"
                                  >
                                    {{ item.letterIndex + ". " }}
                                    {{ item.description }}
                                  </template>
                                  <template
                                    v-slot:expanded-item="{ headers, item }"
                                  >
                                    <td :colspan="headers.length" class="pa-4">
                                      <div class="text-subtitle-1 py-1">
                                        Programs, Activities and Projects
                                      </div>
                                      <div>
                                        <v-data-table
                                          :expanded4.sync="expanded4"
                                          :headers="pap_headers"
                                          single-expand
                                          :items="item.pap_data"
                                          @item-expanded="loadTagged"
                                          show-expand
                                          hide-default-footer
                                        >
                                          <template
                                            v-slot:[`item.kpi`]="{ item }"
                                          >
                                            <b>{{ item.code + ": " }}</b>
                                            {{ item.indicators }}
                                          </template>
                                          <template
                                            v-slot:expanded-item="{
                                              headers,
                                              item,
                                            }"
                                          >
                                            <td
                                              :colspan="headers.length"
                                              class="pa-4"
                                            >
                                              <div class="text-subtitle-1 py-1">
                                                Annual Target Distribution and
                                                Annual Budget Requirement
                                              </div>

                                              <v-data-table
                                                :expanded5.sync="expanded5"
                                                :headers="annual_target_headers"
                                                :items="item.annual_target_dist"
                                                show-expand
                                                hide-default-footer
                                              >
                                                <template
                                                  v-slot:[`item.desc`]="{
                                                    item,
                                                  }"
                                                >
                                                  <div>
                                                    {{ item.description }}
                                                  </div>
                                                </template>
                                                <template
                                                  v-slot:[`item.budget_requirement`]="{
                                                    item,
                                                  }"
                                                >
                                                  <div>
                                                    {{
                                                      item.budget_requirement
                                                        ? formatPrice(
                                                            item.budget_requirement
                                                          )
                                                        : ""
                                                    }}
                                                  </div>
                                                </template>
                                                <template
                                                  v-slot:[`item.tagged`]="{
                                                    item,
                                                  }"
                                                >
                                                  <div>
                                                    {{ item.tagged.length }}
                                                  </div>
                                                </template>

                                                <template
                                                  v-slot:expanded-item="{
                                                    headers,
                                                    item,
                                                  }"
                                                >
                                                  <td
                                                    :colspan="headers.length"
                                                    class="pa-4"
                                                  >
                                                    <!-- <div
                                                      class="text-subtitle-1 py-1"
                                                    >
                                                      {{ item.year }}
                                                    </div> -->

                                                    <table
                                                      class="annual_dist_tbl"
                                                    >
                                                      <thead>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style="background-color: green;"
                                                            class="pa-2 white--text"
                                                          >
                                                            Name
                                                          </td>
                                                          <td
                                                            align="center"
                                                            style="background-color: green;"
                                                            class="pa-2 white--text"
                                                          >
                                                            Office
                                                          </td>
                                                          <td
                                                            align="center"
                                                            style="background-color: green;"
                                                            class="pa-2 white--text"
                                                          >
                                                            Target
                                                          </td>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr
                                                          v-for="(i,
                                                          idx) in item.tagged"
                                                          :key="idx"
                                                        >
                                                          <td
                                                            align="center"
                                                            class="pa-2"
                                                          >
                                                            {{
                                                              i.head_user.name.toUpperCase()
                                                            }}
                                                          </td>
                                                          <td
                                                            align="center"
                                                            class="pa-2"
                                                          >
                                                            {{
                                                              i.head_user.office
                                                            }}
                                                          </td>
                                                          <td
                                                            align="center"
                                                            class="pa-2"
                                                          >
                                                            {{ i.target }}
                                                          </td>
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            colspan="2"
                                                            align="center"
                                                            class="pa-2"
                                                          >
                                                            Total
                                                          </td>
                                                          <td
                                                            align="center"
                                                            class="pa-2"
                                                          >
                                                            {{
                                                              getTaggedTargetTotal(
                                                                item.tagged
                                                              )
                                                            }}
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </template>
                                              </v-data-table>

                                              <!-- <div>
                                                <table class="annual_dist_tbl">
                                                  <thead>
                                                    <tr>
                                                      <td
                                                        align="center"
                                                        style="background-color: green;"
                                                        class="pa-2 white--text"
                                                        v-for="yr in getAnnualTargetHeader(
                                                          item.annual_target_dist
                                                        )"
                                                        :key="yr"
                                                      >
                                                        {{ yr }}
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr>
                                                      <td
                                                        v-for="(i,
                                                        ctr) in item.annual_target_dist"
                                                        :key="ctr"
                                                      >
                                                        <div
                                                          style="width: 100%;"
                                                          class="d-flex justify-space-between"
                                                        >
                                                          <div
                                                            style="width: 70%;"
                                                          >
                                                            <div
                                                              class="text-caption text-center pa-2"
                                                            >
                                                              {{
                                                                i.description
                                                              }}
                                                            </div>
                                                            <div
                                                              style="border-top: 1px solid grey"
                                                              class="text-caption text-center pa-2"
                                                            >
                                                              {{
                                                                i.budgetary_requirement
                                                              }}
                                                            </div>
                                                          </div>
                                                          <div
                                                            style="width: 30%;border-left: 1px solid grey"
                                                            class="d-flex justify-center align-center"
                                                          >
                                                            <v-btn
                                                              class="white--text wrap"
                                                              x-small
                                                              color="warning"
                                                              @click="
                                                                isExpanded = !isExpanded
                                                              "
                                                              >View
                                                              Tagged</v-btn
                                                            >
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                              <v-expand-transition>
                                                <div v-show="isExpanded">
                                                  EM+XPANDED
                                                </div>
                                              </v-expand-transition> -->
                                            </td>
                                          </template>
                                        </v-data-table>
                                      </div>
                                    </td>
                                  </template>
                                </v-data-table>
                              </div>
                            </td>
                          </template>
                        </v-data-table>
                      </div>
                    </td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <!-- <v-fab-transition v-if="isSubmitted">
            <v-menu top>
              <template v-slot:activator="{ on }">
                <v-btn color="#519043" left outlined v-on="on">
                  Remarks
                </v-btn>
              </template>

              <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                <v-card-title class="dialog-header  white--text">
                  <span class="text-h6">Remarks</span>
                </v-card-title>
                <v-card-text
                  class="py-0"
                  style="background-color:white;  height : 300px; overflow-y:auto"
                >
                  <v-timeline dense v-if="remarksData.length > 0">
                    <v-timeline-item
                      v-for="item in remarksData"
                      :key="item.id"
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-h6">
                          {{
                            $store.getters.getUserData.id ==
                            item.remarks_maker_userID
                              ? "You"
                              : item.remarks_by
                          }}
                        </div>
                        <div class="text-body-1">
                          {{ item.message }}
                        </div>
                        <div class="text-caption">
                          <i>{{ formatDate(item.created_at) }}</i>
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                  <v-timeline dense v-if="remarksData.length == 0">
                    <v-timeline-item
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-body-1">
                          No remarks found.
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-fab-transition> -->
          <v-spacer></v-spacer>

          <v-btn color="red" outlined @click="closeD()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <!-- <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()">
            Close
          </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmDelete()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <!-- <v-dialog v-model="confirmSubmitDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to submit this
              <b>Targets for Approval</b>?<br />=
            </p>
          </div>
        </div>
      </v-card>
    </v-dialog> -->
    <!-- <addStrategy :data="targetData" :action="action" />
    <ViewPAP :data="viewTargetData" :action="action" /> -->

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    // addStrategy: () => import("./AddStrategy.vue"),
    // ViewPAP: () => import("./ViewPAP.vue"),
  },
  props: {
    data: null,
  },
  data() {
    return {
      remarksData: [],
      expanded1: [],
      expanded2: [],
      expanded3: [],
      expanded4: [],
      expanded5: [],
      isExpanded: false,
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      viewTargetData: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 2, name: "Strategic Priority" },
      tab: 2,
      tabList: [{ id: 2, name: "Strategic Priority" }],
      targetData: null,
      ipcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      dataItem: [],
      isButtonLoading: false,
      headers: [
        {
          text: "Description",
          value: "description",
          align: "start",
          valign: "start",
          width: "50%",
          sortable: false,
        },
        {
          text: "Number of Strategic Outcomes",
          value: "so_count",
          align: "center",
          valign: "start",
          sortable: false,
        },
        // {
        //   text: "Goal Assigned",
        //   value: "vp_goal_role_description",
        //   align: "start",
        //   valign: "start",
        //   sortable: false,
        // },
      ],
      strategy_outcome_headers: [
        {
          text: "Description",
          value: "description",
          align: "start",
          valign: "start",
          width: "50%",
          sortable: false,
        },
        {
          text: "Number of Strategies",
          value: "strat_count",
          align: "center",
          valign: "start",
          sortable: false,
        },
      ],
      strategy_headers: [
        {
          text: "Description",
          value: "description",
          align: "start",
          valign: "start",
          width: "50%",
          sortable: false,
        },
        {
          text: "Number of PAP",
          value: "pap_count",
          align: "center",
          valign: "start",
          sortable: false,
        },
      ],
      pap_headers: [
        {
          text: "Key Performance Indicators",
          value: "kpi",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Definition and Specifics",
          value: "def_specs",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Baseline",
          value: "baseline",
          align: "center",
          width: 200,
          valign: "center",
          sortable: false,
        },

        {
          text: "SDP Target",
          value: "sdp_target",
          align: "center",
          width: 200,
          valign: "center",
          sortable: false,
        },
      ],
      annual_target_headers: [
        {
          text: "Year",
          value: "year",
          align: "start",
          valign: "start",

          sortable: false,
        },
        {
          text: "Target Distribution",
          value: "target_distribution",
          align: "center",

          sortable: false,
        },
        {
          text: "Budget Requirement",
          value: "budget_requirement",
          align: "center",

          sortable: false,
        },
        {
          text: "Tagged",
          value: "tagged",
          align: "center",

          sortable: false,
        },
      ],
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.expanded1 = [];
        this.expanded2 = [];
        this.expanded3 = [];
        this.expanded4 = [];
        this.expanded5 = [];
        this.id = data.id;
        console.log("STRAT ", data.id);
        // this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeaddStrategy", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewPAP", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeaddStrategy");
    this.eventHub.$off("closeViewPAP");
  },

  methods: {
    initialize() {
      this.expanded1 = [];
      this.expanded2 = [];
      this.expanded3 = [];
      this.expanded4 = [];
      this.expanded5 = [];
      this.loading = true;
      if (this.id) {
        this.axiosCall("/strategic-planning/getGoals/" + this.id, "GET").then(
          (res) => {
            if (res) {
              this.dataItem = res.data;
              console.log("GOLAD", res.data);
              this.loading = false;
            }
          }
        );
      }
    },

    getTaggedTargetTotal(tagged) {
      if (tagged.length > 0) {
        let t = 0;
        for (let i = 0; i < tagged.length; i++) {
          t += parseInt(tagged[i].target);
        }
        return t;
      } else {
        return null;
      }
    },

    loadStrategicOutcomes({ item }) {
      let index = this.dataItem.findIndex((e) => e.id == item.id);

      let goalID = item.id;
      this.axiosCall(
        "/strategic-planning/getStrategicOutcomeByGoal/" +
          this.id +
          "/" +
          goalID,
        "GET"
      ).then((res) => {
        Object.assign(this.dataItem[index], {
          strategy_outcome_data: res.data,
        });
      });
    },

    loadSOStategies({ item }) {
      console.log(item);
      let goalIndex = this.dataItem.findIndex((e) => e.id == item.goalID);
      let soIndex = this.dataItem[goalIndex].strategy_outcome_data.findIndex(
        (e) => e.id == item.id
      );
      let goalID = item.goalID;
      let soID = item.id;

      this.axiosCall(
        "/strategic-planning/getStrategyByStrategicOutcomeAndGoal/" +
          this.id +
          "/" +
          goalID +
          "/" +
          soID,
        "GET"
      ).then((res) => {
        Object.assign(this.dataItem[goalIndex].strategy_outcome_data[soIndex], {
          strategy_data: res.data,
        });
      });
    },
    loadPAP({ item }) {
      let goalIndex = this.dataItem.findIndex((e) => e.id == item.goalID);

      let soIndex = this.dataItem[goalIndex].strategy_outcome_data.findIndex(
        (e) => e.id == item.strategic_outcomeID
      );
      let stratIndex = this.dataItem[goalIndex].strategy_outcome_data[
        soIndex
      ].strategy_data.findIndex((e) => e.id == item.id);

      let goalID = item.goalID;
      let soID = item.strategic_outcomeID;
      let strategyID = item.id;
      this.axiosCall(
        "/strategic-planning/getPAPByStrategyStrategicOutcomeAndGoal/" +
          goalID +
          "/" +
          soID +
          "/" +
          strategyID,
        "GET"
      ).then((res) => {
        console.log(res.data);
        Object.assign(
          this.dataItem[goalIndex].strategy_outcome_data[soIndex].strategy_data[
            stratIndex
          ],
          {
            pap_data: res.data,
          }
        );
      });
    },

    loadTagged({ item }) {
      let goalIndex = this.dataItem.findIndex((e) => e.id == item.goalID);
      let soIndex = this.dataItem[goalIndex].strategy_outcome_data.findIndex(
        (e) => e.id == item.strategicOutcomeID
      );
      let stratIndex = this.dataItem[goalIndex].strategy_outcome_data[
        soIndex
      ].strategy_data.findIndex((e) => e.id == item.strategyID);

      let papIndex = this.dataItem[goalIndex].strategy_outcome_data[
        soIndex
      ].strategy_data[stratIndex].pap_data.findIndex((e) => e.id == item.id);
      // console.log(
      //   "data item",
      //   this.dataItem[goalIndex].strategy_outcome_data[soIndex].strategy_data[
      //     stratIndex
      //   ]
      // );
      // let goalID = item.goalID;
      // let soID = item.strategicOutcomeID;
      // let strategyID = item.strategyID;
      // console.log("called", item);
      // // console.log("Tagged", item);
      this.axiosCall("/strategic-planning/getPAPTagged/" + item.id, "GET").then(
        (res) => {
          console.log(res.data);
          Object.assign(
            this.dataItem[goalIndex].strategy_outcome_data[soIndex]
              .strategy_data[stratIndex].pap_data[papIndex],
            {
              annual_target_dist: res.data,
            }
          );
        }
      );
    },

    getAnnualTargetHeader(item) {
      let arr = [];
      for (let i = 0; i < item.length; i++) {
        arr.push(item[i].year);
      }
      return arr;
    },

    closeD() {
      this.eventHub.$emit("closeViewStratPlanSummaryDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },
    View(item) {
      console.log(item);
      this.viewTargetData = item;
      this.action = "View";
    },

    edit(item) {
      console.log(item);
      this.targetData = item;
      this.action = "Update";
    },

    AddFunction() {
      this.targetData = { id: null, spID: this.id };
      this.action = "Add";
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    confirmDelete() {
      this.isButtonLoading = true;
      console.log(this.itemToDelete.id);
      this.axiosCall(
        "/strategic-planning/deleteTarget/" + this.itemToDelete.id,
        "DELETE"
      ).then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
          this.itemToDelete = null;
          this.confirmDialog = false;

          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
        }
      });
    },
  },
};
</script>
<style scoped>
.annual_dist_tbl {
  width: 100%;
  border-collapse: collapse;
}
.annual_dist_tbl td,
.annual_dist_tbl th {
  border: 1px solid grey;
}
</style>
